import { Button, Form, Input, message, Select, Upload } from 'antd';
import axios from 'axios';
import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import UploadButton from '../../../components/UploadButton';

function EditBlog() {
    const { TextArea } = Input;
    const [backgroundImage, setBackgroundImage] = useState(null);
    const location = useLocation();
    const navigate = useNavigate();
    const data = location.state?.data;
    const [form] = Form.useForm();
    const accessToken = useSelector((state) => state.user.accessToken);
    const API_URL = import.meta.env.VITE_API_URL;
    const [categoryList, setCategoryList] = useState([])
    const [image, setImage] = useState('')

    useEffect(() => {
        if (data?.image) {
            setImage(data.image);
        }
        // console.log("Category ID:", data?.categoryDetails?.id); // Add this line
        form.setFieldsValue({
            title: data?.title,
            title_ar:data?.title_ar,
            Category: data?.categoryDetails?.id, // Ensure this is correct
            description: data?.description,
            description_ar: data?.description_ar,
        });
    }, [data, form]);

    useEffect(() => {
        fetchCategories()
    }, [])
    const fetchCategories = async () => {
        try {
            const response = await axios.get(`${API_URL}Diseases/get-diseases`, {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
            });
            const Diseases = response.data.Diseases.map(d => ({
                id: d.id,
                name: d.name,
            }));
            setCategoryList(Diseases)
        } catch (error) {
            console.error("Error fetching categories:", error);
            return [];
        }
    }

    const handleDiscard = () => {
        navigate(-1);
    };
    const handleSave = async (values) => {
        const payload = {};

        if (values.title !== data.title) {
            payload.title = values.title;
        }
        if (values.title_ar !== data.title_ar) {
            payload.title_ar = values.title_ar;
        }
        if (values.description !== data.description) {
            payload.description = values.Paragraph;
        }
        if (values.description_ar !== data.description_ar) {
            payload.description_ar = values.description_ar;
        }
        if (values.Category && values.Category !== data.categoryDetails.id) {
            payload.category = values.Category;
        }
        if (image !== data.image) {
            payload.image = image;
        }
        if (Object.keys(payload).length === 0) {
            console.log("No changes detected. Not sending request.");
            message.warning("No changes detected")
            return; // Exit the function
        }

        try {
            const response = await axios.patch(`${API_URL}Blogs?id=${data.id}`, payload, {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
            });
            console.log(response);
            message.success("Blog updated successfully.");
            navigate(-1);
            form.resetFields();
        } catch (error) {
            console.error("Error updating blog:", error);
        }
    }


    return (
        <div className="bg-white p-8 rounded flex flex-col space-y-5">
            <p className="text-3xl font-semibold">Edit Blog</p>
            <Form
                form={form}
                layout="vertical"
                onFinish={handleSave}
            >
                <Form.Item name="image">
                    <div
                        className={`flex justify-center items-center min-h-96 bg-cover bg-center bg-no-repeat rounded-sm relative`}
                        style={{
                            backgroundImage: image ? `url(${image})` : "none",
                            backgroundColor: !image ? "#F7F8FF" : "transparent",
                        }}
                    >
                        <div
                            className="absolute inset-0 bg-[#3371EB] opacity-50 pointer-events-none rounded-sm"
                        ></div>

                        <UploadButton
                            onChange={(url) => setImage(url)}
                            disabled={false}
                        />
                    </div>

                </Form.Item>
                <Form.Item
                    label={<p style={{ color: "#232323", fontWeight: 500, fontSize: "16px", }} >Title Blog (EN)</p>}
                    name="title"
                    rules={[{ required: true, message: "Please Enter a Title Blog" },
                    {
                        whitespace: true,
                        message: "No white Space"
                    }]}
                >
                    <Input />
                </Form.Item>
                <Form.Item
                    label={<p style={{ color: "#232323", fontWeight: 500, fontSize: "16px", }} >Title Blog (AR)</p>}
                    name="title_ar"
                    rules={[{ required: true, message: "Please Enter a Title Blog" },
                    {
                        whitespace: true,
                        message: "No white Space"
                    }]}
                >
                    <Input />
                </Form.Item>
                <Form.Item
                    label={<p style={{ color: "#232323", fontWeight: 500, fontSize: "16px", }}>Category</p>}
                    name="Category"
                >
                    <Select placeholder="Select a category">
                        {categoryList.map(category => (
                            <Select.Option key={category.id} value={category.id}>
                                {category.name}
                            </Select.Option>
                        ))}
                    </Select>
                </Form.Item>
                <Form.Item
                    label={<p style={{ color: "#232323", fontWeight: 500, fontSize: "16px", }}>Paragraph (EN)</p>}
                    name="description"
                    rules={[{ required: true, message: "Please Enter a Title Blog" },
                    {
                        whitespace: true,
                        message: "No white Space"
                    }]}
                >
                    <TextArea rows={4} />
                </Form.Item>
                <Form.Item
                    label={<p style={{ color: "#232323", fontWeight: 500, fontSize: "16px", }}>Paragraph (AR)</p>}
                    name="description_ar"
                    rules={[{ required: true, message: "Please Enter a Title Blog" },
                    {
                        whitespace: true,
                        message: "No white Space"
                    }]}
                >
                    <TextArea rows={4} />
                </Form.Item>

                <div className="flex flex-row justify-between items-center">
                    <Button
                        className="px-9 py-6 text-[#3371EB] border-[#E0EAFC]"
                        onClick={handleDiscard}
                    >
                        Discard
                    </Button>
                    <Button type="primary" className="px-7 py-6" htmlType="submit" >
                        Save Changes
                    </Button>
                </div>
            </Form>
        </div>
    );
}

export default EditBlog;
